export const appConfig = {
  apiUrl: 'https://api.tibetmed.md/api',
  defaultAppointmentUrl: "https://n540730.alteg.io",
  appointmentUrls: {
    en: "https://n540730.alteg.io",
    ro: "https://n535124.alteg.io",
    ru: "https://n540727.alteg.io",
  },
  logoFile: "logo.png",
  contacts: {
    phone: '+373 22 00-11-22',
    phone_mob: '+373 684-084-84',
    email: 'info.tibetmed@gmail.com',
    facebook_url: 'https://www.facebook.com/tibetmed.md',
    instagram_url: 'https://www.instagram.com/tibetmed_md',
    address: {
      en: '30 Vlaicu Pârcălab Street, Chișinău, Moldova',
      ro: 'Strada Vlaicu Pârcălab 30, Chișinău, Moldova',
      ru: 'ул. Влайку Пыркэлаб 30, Кишинев, Молдова',
    },
    openingHours: {
      mon_fri: { opens: '08:00', closes: '21:00' },
      saturday: { opens: '08:00', closes: '21:00' },
      sunday: { opens: '09:00', closes: '18:00' },
    }
  }
}
